/*/
 * Form validation
/*/
	window.addEventListener('load', _ => {
		'use strict'

		const forms = document.querySelectorAll('[site-validate]')

		Array.from(forms).forEach(function (form) {
			form.addEventListener('submit', function (event) {
				const button = this.querySelector('[type=submit]')
				const fieldset = this.querySelector('fieldset')
				const formReturnSuccess = form.dataset.success
				const formReturnError = form.dataset.error

				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()

					const invalid = this.querySelector(':invalid')
					invalid.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'center'
					})
					setTimeout(() => {
						invalid.focus()
					}, 750);
				} else {
					event.preventDefault()

					const data = new FormData(this)

					button.classList.add('is--loading')
					button.disabled = true
					fieldset.disabled = true;

					const options = {
						headers: { 'content-type': 'multipart/form-data' }
					}

					window.axios.post(this.action, data, options)
					.then(_ => {
						form.reset()
						form.classList.remove('is--validated')

						siteAlert({
							text: formReturnSuccess,
							class: 'alert--i_success',
							seconds: 12000
						})
					}).catch(err => {
						console.error(err)

						siteAlert({
							text: formReturnError,
							class: 'alert--i_error',
							seconds: 7000
						})
					}).finally(_ => {
						setTimeout(() => {
							button.classList.remove('is--loading')
							button.disabled = false
							fieldset.disabled = false
						}, 1500);
					})
				}

				form.classList.add('is--validated')
			}, false)
		})
	})
